import { useTheme } from '@mui/material';

export const UserIcon = () => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={58} height={58} fill="none">
            <path
                fill={primaryIconStrokeColor}
                d="M36.25 19.333a7.249 7.249 0 0 0-13.948-2.774 7.249 7.249 0 0 0 11.825 7.9 7.25 7.25 0 0 0 2.123-5.126Zm-16.917 0a9.667 9.667 0 1 1 19.334 0 9.667 9.667 0 0 1-19.334 0Zm-3.98 26.584H42.64l-3.338-10.875H18.699l-3.346 10.875Zm1.564-13.292h24.166l4.093 13.292.74 2.416H12.084l.74-2.416 4.094-13.292Z"
            />
        </svg>
    );
};
